import Vue from 'vue';
import Vuex from 'vuex';
import login from '@/modules/login/store';
import auth from '@/store/auth';
import user from '@/store/user';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    login,
    auth,
    user,
  },
});
